import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Badge } from '../ui/badge';

export const DomandeBusinessTab = ({ questions = [] }) => (
  <section className="space-y-3" data-testid="business-questions-tab-content">
    {questions.map((question, index) => (
      <div key={question.id} className="grid gap-3 rounded-lg border border-slate-200 bg-white p-4 md:grid-cols-[150px_1fr_220px] md:items-center" data-testid={`business-question-row-${index}`}>
        <Badge variant="outline" className="w-fit"><HelpCircle className="mr-1 h-3 w-3" />{question.area}</Badge>
        <p className="font-medium text-slate-900" data-testid={`business-question-text-${index}`}>{question.question}</p>
        <div><p className="text-xs uppercase text-slate-500">Blocca</p><p className="text-sm text-slate-700">{question.blocking_for}</p></div>
      </div>
    ))}
  </section>
);